// extracted by mini-css-extract-plugin
var _1 = "active";
var _2 = "align-bottom";
var _3 = "align-center";
var _4 = "align-justify";
var _5 = "align-left";
var _6 = "align-top";
var _7 = "boldtext";
var _8 = "buttonwidth";
var _9 = "capitalize";
var _a = "card";
var _b = "card-block";
var _c = "card-blocks";
var _d = "color-gray";
var _e = "content-divider";
var _f = "disabled";
var _10 = "focus";
var _11 = "heading-link";
var _12 = "hover";
var _13 = "in-dark-background";
var _14 = "input-state-help";
var _15 = "margin-bot-xx-large";
var _16 = "margin-bot-zero";
var _17 = "margin-bottom";
var _18 = "margin-dropdowntop";
var _19 = "margin-hinttop";
var _1a = "margin-left-medium";
var _1b = "margin-top";
var _1c = "margin-top-small";
var _1d = "margin-top-x-large";
var _1e = "margin-top-xx-large";
var _1f = "margin-top-xx-small";
var _20 = "medium-container";
var _21 = "padding-bottom";
var _22 = "padding-left";
var _23 = "padding-top";
var _24 = "shorten-divider";
var _25 = "spin";
var _26 = "tds-a";
var _27 = "tds-action-button-wrapper";
var _28 = "tds-alert--dismissible";
var _29 = "tds-alert--error";
var _2a = "tds-alert--has-inner-icon";
var _2b = "tds-alert--info";
var _2c = "tds-alert--success";
var _2d = "tds-alert--warning";
var _2e = "tds-alert-sitewide-layout";
var _2f = "tds-alert-sitewide-region";
var _30 = "tds-alert-sitewide__title";
var _31 = "tds-alert__dismiss";
var _32 = "tds-alert__inner-action";
var _33 = "tds-alert__inner-container";
var _34 = "tds-alert__inner-text";
var _35 = "tds-alert__title";
var _36 = "tds-app-alert--error";
var _37 = "tds-app-alert--has-inner-icon";
var _38 = "tds-app-alert--info";
var _39 = "tds-app-alert--success";
var _3a = "tds-app-alert--warning";
var _3b = "tds-app-alert-sitewide-layout";
var _3c = "tds-app-alert-sitewide-region";
var _3d = "tds-app-alert-sitewide__title";
var _3e = "tds-app-alert__inner-action";
var _3f = "tds-app-alert__inner-container";
var _40 = "tds-app-alert__inner-text";
var _41 = "tds-app-alert__title";
var _42 = "tds-app-wrapper";
var _43 = "tds-blockquote";
var _44 = "tds-body";
var _45 = "tds-bold";
var _46 = "tds-button";
var _47 = "tds-button--ghost";
var _48 = "tds-button--primary";
var _49 = "tds-button--secondary";
var _4a = "tds-button--small";
var _4b = "tds-button--tertiary";
var _4c = "tds-button-container";
var _4d = "tds-button__icon";
var _4e = "tds-button__icon--first";
var _4f = "tds-button__icon--last";
var _50 = "tds-check";
var _51 = "tds-check__description";
var _52 = "tds-container";
var _53 = "tds-container--full-width";
var _54 = "tds-container-fluid";
var _55 = "tds-desktop";
var _56 = "tds-fieldset";
var _57 = "tds-global-footer";
var _58 = "tds-global-footer-cap";
var _59 = "tds-global-footer__copy";
var _5a = "tds-global-footer__disclaimer";
var _5b = "tds-global-footer__link-group";
var _5c = "tds-global-footer__link-group-heading";
var _5d = "tds-global-footer__link-item";
var _5e = "tds-global-footer__links";
var _5f = "tds-global-footer__logo";
var _60 = "tds-global-footer__social";
var _61 = "tds-global-footer__social-item";
var _62 = "tds-global-footer__wrapper";
var _63 = "tds-global-header";
var _64 = "tds-global-header__actions-block";
var _65 = "tds-global-header__actions-item";
var _66 = "tds-global-header__identity";
var _67 = "tds-global-header__identity-block";
var _68 = "tds-global-header__identity-block--center";
var _69 = "tds-global-header__logo";
var _6a = "tds-global-header__menu-wrapper";
var _6b = "tds-global-header__product";
var _6c = "tds-global-header__wrapper";
var _6d = "tds-h1";
var _6e = "tds-h1--article";
var _6f = "tds-h1--large";
var _70 = "tds-h1--small";
var _71 = "tds-h2";
var _72 = "tds-h2--article";
var _73 = "tds-h2--link";
var _74 = "tds-h2--link-underline";
var _75 = "tds-h3";
var _76 = "tds-h3--article";
var _77 = "tds-h3--link";
var _78 = "tds-h3--link-underline";
var _79 = "tds-h4";
var _7a = "tds-h4--link";
var _7b = "tds-h4--link-underline";
var _7c = "tds-h4--navigation";
var _7d = "tds-h5";
var _7e = "tds-h5--error";
var _7f = "tds-h5--info";
var _80 = "tds-h5--link";
var _81 = "tds-h5--link-underline";
var _82 = "tds-h5--success";
var _83 = "tds-h5--warning";
var _84 = "tds-h6";
var _85 = "tds-h6--link";
var _86 = "tds-h6--link-underline";
var _87 = "tds-iconbutton";
var _88 = "tds-iconbutton--large";
var _89 = "tds-iconbutton--small";
var _8a = "tds-iconbutton--xlarge";
var _8b = "tds-iconbutton__icon";
var _8c = "tds-inline-alert--error";
var _8d = "tds-inline-alert--info";
var _8e = "tds-inline-alert--success";
var _8f = "tds-inline-alert--warning";
var _90 = "tds-inline-alert__title";
var _91 = "tds-input";
var _92 = "tds-italic";
var _93 = "tds-large";
var _94 = "tds-legend";
var _95 = "tds-li";
var _96 = "tds-list-inline";
var _97 = "tds-list-unstyled";
var _98 = "tds-mobile";
var _99 = "tds-nav";
var _9a = "tds-nav__toggle--menu";
var _9b = "tds-p";
var _9c = "tds-screen-readers-only";
var _9d = "tds-screen-readers-only__focusable";
var _9e = "tds-skip-link";
var _9f = "tds-small";
var _a0 = "tds-sr-only";
var _a1 = "tds-sr-only__focusable";
var _a2 = "tds-ul";
var _a3 = "tds-x-small";
var _a4 = "type-color__gray-dark";
var _a5 = "type-color__gray-light";
var _a6 = "type-color__teal-dark";
var _a7 = "type-color__white";
var _a8 = "view-container-medium";
var _a9 = "visited";
export { _1 as "active", _2 as "align-bottom", _3 as "align-center", _4 as "align-justify", _5 as "align-left", _6 as "align-top", _7 as "boldtext", _8 as "buttonwidth", _9 as "capitalize", _a as "card", _b as "card-block", _c as "card-blocks", _d as "color-gray", _e as "content-divider", _f as "disabled", _10 as "focus", _11 as "heading-link", _12 as "hover", _13 as "in-dark-background", _14 as "input-state-help", _15 as "margin-bot-xx-large", _16 as "margin-bot-zero", _17 as "margin-bottom", _18 as "margin-dropdowntop", _19 as "margin-hinttop", _1a as "margin-left-medium", _1b as "margin-top", _1c as "margin-top-small", _1d as "margin-top-x-large", _1e as "margin-top-xx-large", _1f as "margin-top-xx-small", _20 as "medium-container", _21 as "padding-bottom", _22 as "padding-left", _23 as "padding-top", _24 as "shorten-divider", _25 as "spin", _26 as "tds-a", _27 as "tds-action-button-wrapper", _28 as "tds-alert--dismissible", _29 as "tds-alert--error", _2a as "tds-alert--has-inner-icon", _2b as "tds-alert--info", _2c as "tds-alert--success", _2d as "tds-alert--warning", _2e as "tds-alert-sitewide-layout", _2f as "tds-alert-sitewide-region", _30 as "tds-alert-sitewide__title", _31 as "tds-alert__dismiss", _32 as "tds-alert__inner-action", _33 as "tds-alert__inner-container", _34 as "tds-alert__inner-text", _35 as "tds-alert__title", _36 as "tds-app-alert--error", _37 as "tds-app-alert--has-inner-icon", _38 as "tds-app-alert--info", _39 as "tds-app-alert--success", _3a as "tds-app-alert--warning", _3b as "tds-app-alert-sitewide-layout", _3c as "tds-app-alert-sitewide-region", _3d as "tds-app-alert-sitewide__title", _3e as "tds-app-alert__inner-action", _3f as "tds-app-alert__inner-container", _40 as "tds-app-alert__inner-text", _41 as "tds-app-alert__title", _42 as "tds-app-wrapper", _43 as "tds-blockquote", _44 as "tds-body", _45 as "tds-bold", _46 as "tds-button", _47 as "tds-button--ghost", _48 as "tds-button--primary", _49 as "tds-button--secondary", _4a as "tds-button--small", _4b as "tds-button--tertiary", _4c as "tds-button-container", _4d as "tds-button__icon", _4e as "tds-button__icon--first", _4f as "tds-button__icon--last", _50 as "tds-check", _51 as "tds-check__description", _52 as "tds-container", _53 as "tds-container--full-width", _54 as "tds-container-fluid", _55 as "tds-desktop", _56 as "tds-fieldset", _57 as "tds-global-footer", _58 as "tds-global-footer-cap", _59 as "tds-global-footer__copy", _5a as "tds-global-footer__disclaimer", _5b as "tds-global-footer__link-group", _5c as "tds-global-footer__link-group-heading", _5d as "tds-global-footer__link-item", _5e as "tds-global-footer__links", _5f as "tds-global-footer__logo", _60 as "tds-global-footer__social", _61 as "tds-global-footer__social-item", _62 as "tds-global-footer__wrapper", _63 as "tds-global-header", _64 as "tds-global-header__actions-block", _65 as "tds-global-header__actions-item", _66 as "tds-global-header__identity", _67 as "tds-global-header__identity-block", _68 as "tds-global-header__identity-block--center", _69 as "tds-global-header__logo", _6a as "tds-global-header__menu-wrapper", _6b as "tds-global-header__product", _6c as "tds-global-header__wrapper", _6d as "tds-h1", _6e as "tds-h1--article", _6f as "tds-h1--large", _70 as "tds-h1--small", _71 as "tds-h2", _72 as "tds-h2--article", _73 as "tds-h2--link", _74 as "tds-h2--link-underline", _75 as "tds-h3", _76 as "tds-h3--article", _77 as "tds-h3--link", _78 as "tds-h3--link-underline", _79 as "tds-h4", _7a as "tds-h4--link", _7b as "tds-h4--link-underline", _7c as "tds-h4--navigation", _7d as "tds-h5", _7e as "tds-h5--error", _7f as "tds-h5--info", _80 as "tds-h5--link", _81 as "tds-h5--link-underline", _82 as "tds-h5--success", _83 as "tds-h5--warning", _84 as "tds-h6", _85 as "tds-h6--link", _86 as "tds-h6--link-underline", _87 as "tds-iconbutton", _88 as "tds-iconbutton--large", _89 as "tds-iconbutton--small", _8a as "tds-iconbutton--xlarge", _8b as "tds-iconbutton__icon", _8c as "tds-inline-alert--error", _8d as "tds-inline-alert--info", _8e as "tds-inline-alert--success", _8f as "tds-inline-alert--warning", _90 as "tds-inline-alert__title", _91 as "tds-input", _92 as "tds-italic", _93 as "tds-large", _94 as "tds-legend", _95 as "tds-li", _96 as "tds-list-inline", _97 as "tds-list-unstyled", _98 as "tds-mobile", _99 as "tds-nav", _9a as "tds-nav__toggle--menu", _9b as "tds-p", _9c as "tds-screen-readers-only", _9d as "tds-screen-readers-only__focusable", _9e as "tds-skip-link", _9f as "tds-small", _a0 as "tds-sr-only", _a1 as "tds-sr-only__focusable", _a2 as "tds-ul", _a3 as "tds-x-small", _a4 as "type-color__gray-dark", _a5 as "type-color__gray-light", _a6 as "type-color__teal-dark", _a7 as "type-color__white", _a8 as "view-container-medium", _a9 as "visited" }
